function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M14.217 7.5a6.718 6.718 0 1 1-13.435 0 6.718 6.718 0 0 1 13.435 0zm-1 0a5.718 5.718 0 1 0-11.435 0 5.718 5.718 0 0 0 11.435 0z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M5.804 11.957h3.392a.5.5 0 1 0 0-1H5.804a.5.5 0 0 0 0 1z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M7 11.174a.5.5 0 1 0 1 0V6.37a.5.5 0 0 0-.5-.5H6.37a.5.5 0 1 0 0 1H7v4.304zM7.217 3.326a.783.783 0 1 0 0 1.566.783.783 0 0 0 0-1.566z"
});

var SvgInfoIcon = function SvgInfoIcon(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    style: {
      background: "#fff"
    },
    viewBox: "0 0 15 15",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: props.color,
    fillRule: "nonzero"
  }, _ref2, _ref3, _ref4));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgInfoIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/info_icon.bf68a432.svg";
export { ForwardRef as ReactComponent };